export const removeCurrencySeparators = (isEnglish, str) => {
  if (isEnglish) {
    return str.replace(/,/g, '');
  }

  return str.replace(/\./g, '').replace(/,/g, '.');
};
